var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrapper d-inline-block" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-primary",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.open.apply(null, arguments)
          },
        },
      },
      [_c("i", { staticClass: "fas fa-folder-open" })]
    ),
    _vm._v(" "),
    _c("input", {
      ref: "input",
      staticClass: "d-none",
      attrs: { type: "file", multiple: "" },
      on: { change: _vm.onChange },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }